import { put, select } from 'redux-saga/effects';
import { Types } from '../getScheduleUseCase/actions';
import { findAcademicCalendar } from '../getScheduleUseCase/saga';

export default function* execute(action: any): any {
  try {
    const { date } = action;
    const schedule = yield select((state: any) => state.schedule.data);
    const { dates, academicCalendar } = schedule;
    const newAcademicCalendarByWeek = findAcademicCalendar(
      dates,
      academicCalendar,
      date
    );
    const data = {
      ...schedule,
      selectedDate: date,
      academicCalendarByWeek: newAcademicCalendarByWeek
    };
    yield put({
      type: Types.GET_SCHEDULE_SUCCESS,
      data
    });
  } catch (error) {
    yield put({
      type: Types.GET_SCHEDULE_FAILURE,
      error: 'Ocurrió un error'
    });
  }
}
